export default "__VITE_ASSET__a6c27950__"